import React, { useState } from "react";
// import {Purpose, Scheme } from "../../../../core/data/json/apmc"
// import CommonSelect from "./commonSelect"
import { Link, useNavigate } from "react-router-dom";
import SingleView from "../../district/components/SingleView";
import { useSelector } from "react-redux";
import { submitApmcApproveRejectApplication } from "../../../auth/services/privateapicalling";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

interface DistrictPageProps {
    applicationId:any;
    formData: any;
    certificate:any;
    siteInspectionPhotos: any[];
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>void;
     handleFileChange: (e: React.ChangeEvent<HTMLInputElement> , documentName: string) => void;
     handleSubmit:(obj)=>Promise<boolean>;
    //  handleSubmit:()=>any;
     detailAssistanceReceived: any[];
    setDetailAssistanceReceived: React.Dispatch<React.SetStateAction<any[]>>;
    purposes:any[];
    setFormData:any;
    existData:any
     handleAssistanceChange: (index: number, field: keyof any, value: string) => void;
}

// const DistrictPage = ({ formData, handleInputChange, handleFileChange,detailAssistanceReceived,setDetailAssistanceReceived , handleSubmit , purposes , setFormData , existData , handleAssistanceChange}: DistrictPageProps  
//     // existData:any;
// }




const DistrictPage = ({ 
  applicationId,
  handleAssistanceChange,
  certificate,
  formData,
  handleInputChange,
  handleFileChange,
    siteInspectionPhotos,
  detailAssistanceReceived,
  setDetailAssistanceReceived,
  handleSubmit,
  purposes,
  setFormData,
  existData
}: DistrictPageProps) => {

    const [selectedDocId, setSelectedDocId] = useState<string | null>(null);
    const userDetail = useSelector((state:any)=>state.auth.userDetails);
    const roleIdentifier = userDetail.Role.Role_Identifier;
   const navigate = useNavigate()
    const token = useSelector((state:any)=>state.auth.token);
  const [centralComment,setCentralComment]=useState<string>("");


  const handleBack=()=>{
    navigate(-1);
  }


//-----------------------------------------------Validations---------------------------------------------------

const [errors, setErrors] = useState<{ [key: string]: string }>({});
const [agreeTerms, setAgreeTerms] = useState(false);
const [agreeError, setAgreeError] = useState(false);


const fileButtonFn = (fieldName:string , docName:string,anexxure:string) => {
    let docData:any;
    let docId:any;
if(fieldName==="hasAssistanceApproved"){
    
     docData = existData?.[anexxure]?.[fieldName];
   
       docId = docData?.data.find((data:any)=>data.fieldName == docName)?.value?.completion?.docId;
      
}else
 {  docData = existData?.[anexxure]?.[fieldName];
     docId = docData?.data.find((data:any)=>data.documentName == docName)?.docId;
 }
 


  return (
    <Link
    to="#"
    data-bs-toggle="modal"
    data-inert={true}
    data-bs-target="#apmc_modal"
    className="btn btn-outline-info w-75 align-items-center"
    onClick={() => {
      setSelectedDocId(docId);
      
    }}
  >
    <i className="ti ti-eye"></i> View Document
  </Link>
  );
};

  

    const goToCertificate = async () => {

if(roleIdentifier==="SA"){
       navigate('/jcForm', { state: { existData: existData, applicationId: applicationId ,comment:centralComment} });
       return;
}
    if (!agreeTerms &&roleIdentifier!=="SA") {
        setAgreeError(true); 
        toast.error("You must agree to the terms before proceeding.", {
            position: "top-right"
        });
        return;
    }

    try {
        // Normalize the data before submission
        const normalizedData = {
            ...formData,
            estimateProjectCostAmount: normalizeEstimateProjectCostAmount()
        };
        
        // Update formData with normalized data
        setFormData(normalizedData);
        
        const res = await handleSubmit(normalizedData);
        if (!res) {
            toast.error("Annexure 1.1 not submitted. Please try again.", {
                position: "top-right"
            });
            return;
        }

        toast.success("Form saved successfully! Redirecting to certificate...", {
            position: "top-right"
        });
        
        navigate('/jcForm', { state: { existData: existData, applicationId: applicationId ,comment:centralComment} });

    } catch (error) {
       
        toast.error("An error occurred while saving the form.", {
            position: "top-right"
        });
    }
};



const handleFinalSubmit = async (status: string, appStatusLevel: string) => {
       if (!agreeTerms) {
        setAgreeError(true); 
        toast.error("You must agree to the terms before proceeding.", {
            position: "top-right"
        });
        return;
    }
    const normalizedFormData = {
        ...formData,
        estimateProjectCostAmount: normalizeEstimateProjectCostAmount()
    };


    const detailObj = detailAssistanceReceived.reduce((acc, item, index) => {
        acc[`hasAssistanceApproved_${index + 1}`] = item;
        return acc;
    }, {} as any);

    const annexureOnePointOne = {
        ...normalizedFormData,
        ...detailObj
    };

    try {
        // Update formData with normalized data before submitting
        setFormData(normalizedFormData);
        
        const submitFormData = {
            status: status,
            appStatusLevel: appStatusLevel,
            applicationId: applicationId,
            schemeId: existData?.scheme?.id,
            applicationType: "scheme",
            comment: centralComment,
            ...((roleIdentifier === "COM"&&existData?.appStatusLevel==="pendingAtCOM") && {
                positionName: certificate.positionName,
                FilledFormName: certificate.FilledFormName,
                projectCapability: certificate.projectCapability,
                siteInspectionPhotos: siteInspectionPhotos
            }),
        };

        const res = await handleSubmit(normalizedFormData);
        if (!res) {
            toast.error("Form submission failed. Please try again.", {
                position: "top-right"
            });
            return;
        }

        const submitData = await submitApmcApproveRejectApplication(submitFormData, token);
      

        if (submitData.success) {
            let successMessage = "";
            if (submitData?.data?.status === "reject") {
                successMessage = "Query raised successfully!";
                toast.warning(successMessage, { position: "top-right" });
            } else if (submitData?.data?.status === "permanentReject") {
                successMessage = "Application permanently rejected!";
                toast.error(successMessage, { position: "top-right" });
            } else if (submitData?.data?.status === "approvedUnsigned") {
                successMessage = "Application approved successfully!";
                toast.success(successMessage, { position: "top-right" });
            } else {
                successMessage = "Form submitted successfully!";
                toast.success(successMessage, { position: "top-right" });
            }

           setTimeout(() => {
                        navigate("/apmc-application");
                    }, 2000);
        } else {
            toast.error("Submission failed. Please try again.", {
                position: "top-right"
            });
        }

    } catch (error) {
       
        toast.error("An error occurred during submission.", {
            position: "top-right"
        });
    }
};



// Add this function to normalize the data before submission
const normalizeEstimateProjectCostAmount = () => {
    if (!formData?.estimateProjectCostAmount || !Array.isArray(formData.estimateProjectCostAmount)) {
        return [];
    }
    
    const percentage = parseFloat(formData?.percentOfProjCostEligible) || 0;
    
    return formData.estimateProjectCostAmount.map((item: any) => {
        // Calculate the eligible cost
        const calculatedEligibleCost = (item.cost * percentage) / 100;
        
        // Use existing value if present, otherwise use calculated
        const finalEligibleCost = (item.eligibleCost !== undefined && 
                                   item.eligibleCost !== null && 
                                   item.eligibleCost !== "") 
            ? parseFloat(item.eligibleCost) 
            : calculatedEligibleCost;
        
        return {
            ...item,
            eligibleCost: finalEligibleCost.toFixed(2), // ✅ Always include this
            remark: item.remark || ""
        };
    });
};

  return (
    <>
        <ToastContainer position="top-left" autoClose={3000} />
        <div className="w-100 d-flex flex-column align-items-end justify-content-end px-5 ">
            <div className='d-flex flex-column text-nightblue align-items-center justify-content-center  '>
                <div id='table' className='w-100 overflow-hidden border bg-white border-secondary rounded'>
                    <div id='head' className='d-flex w-100 rounded-top border-bottom border-secondary' style={{ backgroundColor: "#CCE3FF" }}>
                        <h4 className='col-1 d-flex justify-content-center align-items-center'>S.No.</h4>
                        <h4 className='col-6 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary'>પ્રશ્ન(Field)</h4>
                        <h4 className='col-5 p-2 justify-content-center d-flex align-items-center'>જવાબ(Response)</h4>
                    </div>
                    
                    <div className='d-flex border-bottom border-secondary'>
                        <h4 className='col-1  d-flex align-items-center justify-content-center'>01.</h4>
                        <div className='col-6 border-start border-end border-secondary  d-flex align-items-center justify-content-center p-2'>
                            <p className='p-2'>ખેતીવાડી ઉત્પન્ન બજાર સમિતિનું નામ અને સરનામું.(Name and address of the Agricultural Produce Market Committee.)*</p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                            <div className="d-flex flex-column w-100 gap-2 align-items-center">
                                <h6>District</h6>
                                <div className="p-2 w-75 text-muted border rounded bg-light">
                                    {existData?.annexureOne?.apmc?.data.find((data: any) => data.fieldName.toLowerCase() == "district")?.value}
                                </div>
                            </div>
                            <div className="d-flex flex-column gap-2 align-items-center w-100">
                                <h6>Taluka</h6>
                                <div className="p-2 w-75 text-muted border rounded bg-light">
                                    {existData?.annexureOne?.apmc?.data.find((data: any) => data.fieldName.toLowerCase() == "taluka")?.value}
                                </div>
                            </div>
                            <div className="d-flex flex-column gap-2 w-100 align-items-center">
                                <h6>APMC</h6>
                                <div className="p-2 w-75 text-muted border rounded bg-light">
                                    {existData?.annexureOne?.apmc?.data.find((data: any) => data.fieldName == "apmcName")?.value}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='d-flex border-bottom border-secondary '>
                        <h4 className='col-1 p-2 d-flex align-items-center justify-content-center'>02.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                            <p className='p-2'>
                                બજાર સમિતિની સ્થાપનાની વિગત (જાહેરનામાની નકલ) (Details of establishment of the Market Committee (Copy of Government Notification)*
                            </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                            {fileButtonFn("copyOfMarketCommitteEstDet", "copyOfMarketCommitteEstDet",'annexureOne')}
                        </div>
                    </div>

                    <div className='d-flex border-bottom border-secondary'>
                        <h4 className='col-1 d-flex align-items-center justify-content-center'>03.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                            <p className='p-2'>બજાર સમિતિનો વર્ગ.<br />
                                (જિલ્લા રજિસ્ટ્રારશ્રીનું પ્રમાણપત્ર) સામેલ છે ? તેની નકલ Category of the Market Committee (Certificate from District Registrar)*</p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                            <div className="d-flex flex-column w-100 gap-2 align-items-center">
                                <h6>Class</h6>
                                <div className="p-2 w-75 text-muted border rounded bg-light">
                                    {existData?.annexureOne?.certOfMarketCommitteCategory?.data?.find((data: any) => data.fieldName == "MarketCommitteCategory")?.value}
                                </div>
                            </div>
                            {fileButtonFn("certOfMarketCommitteCategory", "certOfMarketCommitteCategory","annexureOne")}
                        </div>
                    </div>

                    <div className='d-flex border-bottom border-secondary'>
                        <h4 className='col-1 d-flex align-items-center justify-content-center'>04.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                            <p className='p-2'>
                                કઈ યોજના હેઠળ સહાય મળવાપાત્ર રહે છે (Under which scheme assistance is eligible to be received )
                            </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                            <h6>Scheme</h6>
                            <div className="p-2 w-75 text-muted border rounded bg-light">
                                {existData?.scheme?.name}
                            </div>
                            {/* <h6>Purpose</h6>
                            <div className="p-2 w-75 text-muted border rounded bg-light">
                                {existData?.annexureOne?.purposeOfAssistance?.data.find((data: any) => data.fieldName == "purpose")?.value}
                            </div> */}
                        </div>
                    </div>

                    <div className='d-flex border-bottom border-secondary'>
                        <h4 className='col-1 d-flex align-items-center justify-content-center'>05.</h4>
                        <div className='col-11 p-2 border-start border-secondary d-flex align-items-center justify-content-center'>
                            <p className='p-2'>
                                સહાય મંજુરી બાબતેની વિગતો (Details Regarding Sanction of Assistance)
                            </p>
                        </div>
                    </div>


                    <div className='d-flex border-bottom border-secondary'>
                        <h4 className='col-1 d-flex align-items-center justify-content-center'></h4>
                        <div className='col-11 border-start border-secondary d-flex align-items-center justify-content-center'>
                            {/* <h4 className='col-1 p-2 border-end border-secondary h-100 d-flex align-items-center justify-content-center'>01.</h4> */}
                            <div className='col-12 p-2'>
                                <table className="table table-bordered w-100">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Purpose</th>
                                            <th>Cost</th>
                                            <th>Eligible Cost</th>
                                            <th>Remark</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {formData?.estimateProjectCostAmount && Array.isArray(formData.estimateProjectCostAmount) && formData.estimateProjectCostAmount.length > 0 ? (
                                            formData.estimateProjectCostAmount.map((item: any, index: number) => {
                                                const percentage = parseFloat(formData?.percentOfProjCostEligible) || 0;
                                                const calculatedEligibleCost = (item.cost * percentage) / 100;
                                                
                                                // Use existing eligibleCost if available, otherwise use calculated value
                                                const eligibleCostValue = item.eligibleCost !== undefined && item.eligibleCost !== null && item.eligibleCost !== "" 
                                                    ? item.eligibleCost 
                                                    : calculatedEligibleCost.toFixed(2);
                                                
                                                // Use existing remark if available, otherwise empty string
                                                const remarkValue = item.remark !== undefined && item.remark !== null 
                                                    ? item.remark 
                                                    : "";
                                                
                                                return (
                                                    <tr key={item.id || index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.name || "-"}</td>
                                                        <td>{item.cost || "-"}</td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                name={`eligibleCost_${index}`}
                                                                value={eligibleCostValue}
                                                                onChange={(e) => {
                                                                const updatedArray = formData.estimateProjectCostAmount.map((arrayItem: any, i: number) => {
                                                                    if (i === index) {
                                                                        return {
                                                                            ...arrayItem,
                                                                            eligibleCost: e.target.value,
                                                                            remark: arrayItem.remark !== undefined ? arrayItem.remark : ""
                                                                        };
                                                                    }
                                                                    return arrayItem;
                                                                });
                                                                setFormData({
                                                                    ...formData,
                                                                    estimateProjectCostAmount: updatedArray
                                                                });
                                                                }}
                                                                min="0"
                                                                step="0.01"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name={`remark_${index}`}
                                                                value={remarkValue}
                                                                onChange={(e) => {
                                                                const percentage = parseFloat(formData?.percentOfProjCostEligible) || 0;
                                                                const updatedArray = formData.estimateProjectCostAmount.map((arrayItem: any, i: number) => {
                                                                    if (i === index) {
                                                                        const calculatedEligibleCost = (arrayItem.cost * percentage) / 100;
                                                                        return {
                                                                            ...arrayItem,
                                                                            remark: e.target.value,
                                                                            eligibleCost: arrayItem.eligibleCost !== undefined && arrayItem.eligibleCost !== null && arrayItem.eligibleCost !== "" 
                                                                                ? arrayItem.eligibleCost 
                                                                                : calculatedEligibleCost.toFixed(2)
                                                                        };
                                                                    }
                                                                    return arrayItem;
                                                                });
                                                                setFormData({
                                                                    ...formData,
                                                                    estimateProjectCostAmount: updatedArray
                                                                });
                                                            }}
                                                                placeholder="Enter remark"
                                                            />
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan={5} className="text-center">No data available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                
                                {/* Total Eligible Cost */}
                                {formData?.estimateProjectCostAmount && formData.estimateProjectCostAmount.length > 0 && (
                                    <div className="d-flex justify-content-end mt-3 pe-3">
                                        <strong>
                                            Total Eligible Cost: ₹{" "}
                                            {formData.estimateProjectCostAmount.reduce((total: number, item: any) => {
                                                const percentage = parseFloat(formData?.percentOfProjCostEligible) || 0;
                                                const calculatedEligibleCost = (item.cost * percentage) / 100;
                                                const eligibleCost = item.eligibleCost !== undefined && item.eligibleCost !== null && item.eligibleCost !== "" 
                                                    ? item.eligibleCost 
                                                    : calculatedEligibleCost;
                                                return total + parseFloat(eligibleCost || 0);
                                            }, 0).toFixed(2)}
                                        </strong>
                                    </div>
                                )}
                                
                                {errors["estimateProjectCostAmount"] && (
                                    <p className="text-danger small mt-2">{errors["estimateProjectCostAmount"]}</p>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className='d-flex border-bottom border-secondary'>
                        <h4 className='col-1 d-flex align-items-center justify-content-center'>06.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                            <p className='p-2'>
                                બજાર સમિતિ સરકારશ્રીની સહાય સિવાય રકમ ક્યાંથી ઉભી કરશે. તેની વિગતો (અભિપ્રાય સાથે ) (From where will the Market Committee raise the remaining amount apart from the Government assistance? Details of the same (with opinion).)</p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                     {fileButtonFn("isMarktingCommFinanciallyCapableOfExpense", "marktingCommFinanciallyCapableOfExpense",'annexureThree')}
                        </div>
                    </div>

                    <div className='d-flex border-bottom border-secondary'>
                        <h4 className='col-1 d-flex align-items-center justify-content-center'>07.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                            <p className='p-2'>
                             પ્લાન / એસ્ટીમેન્ટમાં દર્શાવેલ સુચિત કામોનો સમાવેશ પ્લાનમાં થયેલ છે કે કેમ? જે તે જગ્યા ઉપર અન્ય કોઈ બાંધકામ થયેલ છે કે કેમ? ....... આ બાબતે રૂબરૂ સ્થળ તપાસ કરી / કરાવી તેની વિગતો આપવી. પ્લાન / એસ્ટીમેન્ટમાં દર્શાવેલ સુચિત કામોનો સમાવેશ પ્લાનમાં થયેલ છે.(Have the proposed works shown in the plan/estimate been included in the plan? Has any other construction been done at the concerned site? Conduct on-site inspection and provide the details. The proposed works in the plan/estimate have been included.) *
                            </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                           {fileButtonFn("isMarktingCommFinanciallyCapableOfExpense", "marktingCommFinanciallyCapableOfExpense",'annexureThree')}
                           
                        </div>
                    </div>

                    <div className='d-flex border-bottom border-secondary'>
                        <h4 className='col-1 d-flex align-items-center justify-content-center'>08.</h4>
                        <div className='col-6 p-2 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                            <p className='p-2'>
                            બાંધકામની મંજુરી (૧) બાંધકામની મંજુરી કોના દ્વારા ક્યારે આપવામાં આવેલ છે. તેની વિગતો.(Building Permission: (1) Who granted the construction permission and when? Provide details.)
                            </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                          
                     {fileButtonFn("permissionFromAuthority", "permissionFromAuthority","annexureTwo")}
                        </div>
                    </div>
    <div className='d-flex border-bottom border-secondary'>
                        <h4 className='col-1 d-flex align-items-center justify-content-center'>09.</h4>
                        <div className='col-11 p-2 border-start border-secondary d-flex align-items-center '>
                            <p className='p-2'>
                               પ્લાન ( Plan)
                            </p>
                        </div>
                    </div>

                    <div className='d-flex border-bottom border-secondary'>
                        <h4 className='col-1 d-flex align-items-center justify-content-center'></h4>
                        <div className='col-6 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                            <h4 className='col-1 p-2 border-end border-secondary h-100 d-flex align-items-center justify-content-center'>01.</h4>
                            <p className='p-2 col-11'>
                              પ્લાન / એસ્ટીમેન્ટમાં દર્શાવેલ સુચિત જગ્યા પર અન્ય કોઈ બાંધકામ થયેલ છે કે કેમ ?(Has any other construction been done on the proposed site shown in the plan/estimate?)
                            </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                         <div className=' d-flex justify-content-start w-75 gap-2'>
                                <label className="d-flex align-items-center gap-1">
                                    <input
                                        type='radio'
                                        name='isOnsiteInspectionCertDistrictRegistrar'
                                        value="yes"
                                        checked={existData?.annexureOne?.isExistingConstructionOnProjSite?.data.find(data=>data?.fieldName==="isExistingConstructionOnProjSite")?.value === "yes"}
                                        onChange={handleInputChange}
                                        disabled
                                    />
                                    Yes
                                </label>
                                <label className="d-flex align-items-center gap-1">
                                    <input
                                        type='radio'
                                        name='isOnsiteInspectionCertDistrictRegistrar'
                                        value="no"
                                        checked={existData?.annexureOne?.isExistingConstructionOnProjSite?.data.find(data=>data?.fieldName==="isExistingConstructionOnProjSite")?.value === "no"}
                                        onChange={handleInputChange}
                                        disabled
                                    />
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className='d-flex border-bottom border-secondary'>
                        <h4 className='col-1 d-flex align-items-center justify-content-center'></h4>
                        <div className='col-6 border-start border-end border-secondary d-flex align-items-center justify-content-center'>
                            <h4 className='col-1 p-2 border-end border-secondary h-100 d-flex align-items-center justify-content-center'>02.</h4>
                            <p className='p-2 col-11'>
                              દરખાસ્તમાં જે કામ રજુ થયેલ છે. તે કામ માટે અગાઉ સહાય લીધેલ છે કે કેમ ?(Has assistance been taken earlier for the work proposed in the current application?)
                            </p>
                        </div>
                        <div className='col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center'>
                         <div className=' d-flex justify-content-start w-75 gap-2'>
                                <label className="d-flex align-items-center gap-1">
                                    <input
                                        type='radio'
                                        name='hasAssistanceApproved'
                                        value="yes"
                                        checked={existData?.annexureThree?.hasAssistanceApproved?.data.find(data=>data?.fieldName==="isApproved")?.value === "yes"}
                                        onChange={handleInputChange}
                                        disabled
                                    />
                                    Yes
                                </label>
                                <label className="d-flex align-items-center gap-1">
                                    <input
                                        type='radio'
                                        name='hasAssistanceApproved'
                                        value="no"
                                        checked={existData?.annexureThree?.hasAssistanceApproved?.data.find(data=>data?.fieldName==="isApproved")?.value === "no"}
                                        onChange={handleInputChange}
                                        disabled
                                    />
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className='d-flex border-bottom border-secondary'>
                        <h4 className='col-1 d-flex align-items-center justify-content-center'>10.</h4>
                        <div className='col-11 p-2 border-start border-secondary d-flex align-items-start justify-content-start'>
                            <p className='p-2'>
                                આ અગાઉ મેળવેલ સહાયની વિગતો.<br />
                                (Details of assistance received previously.)
                            </p>
                        </div>
                    </div>

                    {/* Enhanced Assistance Details Section */}
                    {errors["assistance_general"] && (
                        <div className="d-flex px-3 py-2 bg-danger bg-opacity-10">
                            <p className="text-danger small mb-0">{errors["assistance_general"]}</p>
                        </div>
                    )}
                    
                    {detailAssistanceReceived.map((block, index) => (
                        
                        <React.Fragment key={index}>
                            {/* Section Heading */}
                            <div className="d-flex px-3 py-2 bg-light border-bottom border-secondary">
                                <strong>
                                    {['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth'][index]} Detail 
                                    {index === 0 && <span className="text-danger">*</span>}
                                </strong>
                            </div>


                            {/* Scheme Field */}
                            <div className="d-flex border-bottom border-secondary">
                                <h4 className="col-1"></h4>
                                <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                                    <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">01.</h4>
                                    <p className="col-10 p-2 d-flex align-items-center">યોજના, હેતુ (Scheme, Purpose) *</p>
                                </div>
                                <div className="col-5 d-flex flex-column gap-2 align-items-center justify-content-center">
                                    <input
                                        type="text"
                                        className="form-control w-75 m-2"
                                        name="scheme"
                                        disabled
                                        value={block.scheme || ""}
                                        onChange={(e) => handleAssistanceChange(index, "scheme", e.target.value)}
                                        placeholder="Enter Scheme"
                                        minLength={3}
                                        maxLength={100}
                                    />
                                       <input
                                        type="text"
                                        className="form-control w-75 m-2"
                                        name="scheme"
                                        value={block.purpose || ""}
                                        onChange={(e) => handleAssistanceChange(index, "scheme", e.target.value)}
                                        placeholder="Enter Scheme"
                                        minLength={3}
                                        disabled
                                        maxLength={100}
                                    />
                                    {errors[`assistance_scheme_${index}`] && (
                                        <p className="text-danger small">{errors[`assistance_scheme_${index}`]}</p>
                                    )}
                                </div>
                            </div>
         <div className="d-flex border-bottom border-secondary">
                                <h4 className="col-1"></h4>
                      <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                        <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">02.</h4>
                        <p className="col-10 p-2 d-flex align-items-center">કુલ પ્રોજેકટની રકમ (Total Project Cost)*</p>
                      </div>
                      <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                        <input
                            type="number"
                            className="form-control w-75 m-2"
                            name="amount"
                            value={block.amount || ""}
                            onChange={(e) => handleAssistanceChange(index, "amount", e.target.value)}
                            placeholder="Enter Amount"
                            disabled
                            min="0"
                            step="0.01"
                            />
                        {errors[`assistance_amount_${index}`] && (
                            <p className="text-danger small">{errors[`assistance_amount_${index}`]}</p>
                        )}
                    </div>
                  </div>
                            {/* Amount Field */}
                            <div className="d-flex border-bottom border-secondary">
                                <h4 className="col-1"></h4>
                      <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                        <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">03.</h4>
                        <p className="col-10 p-2 d-flex align-items-center">મળેલ સહાય – (Assistance Received)*</p>
                      </div>
                      <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                        <input
                            type="number"
                            className="form-control w-75 m-2"
                            name="amount"
                            value={block.assistance || ""}
                            onChange={(e) => handleAssistanceChange(index, "amount", e.target.value)}
                            placeholder="Enter Amount"
                            min="0"
                            disabled
                            step="0.01"
                            />
                        {errors[`assistance_amount_${index}`] && (
                            <p className="text-danger small">{errors[`assistance_amount_${index}`]}</p>
                        )}
                    </div>
                  </div>

                    {/* Total Expenditure Field */}
                    <div className="d-flex border-bottom border-secondary">
                        <h4 className="col-1"></h4>
                        <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                            <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">04.</h4>
                            <p className="col-10 p-2 d-flex align-items-center">કુલ ખર્ચ(Total Expenditure)*</p>
                        </div>
                        <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                          <input
                            type="number"
                            className="w-75 m-2 form-control"
                            placeholder="Total Expenditure"
                            value={block.expenditure}
                            onChange={(e) => handleAssistanceChange(index, "expenditure", e.target.value)}
                            min="0"
                            step="0.01"
                            disabled
                          />
                        {errors[`assistance_expenditure_${index}`] && (
                            <p className="text-danger small">{errors[`assistance_expenditure_${index}`]}</p>
                        )}
                            </div>
                        </div>

                    {/* Increase/Decrease Field */}
                    <div className="d-flex border-bottom border-secondary">
                        <h4 className="col-1"></h4>
                        <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                            <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">05.</h4>
                            <p className="col-10 p-2 d-flex align-items-center">વધ / ધટ –( Excess / Shortfall)*</p>
                        </div>
                        <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                            <input
                                type="number"
                                className="w-75 m-2 form-control"
                                placeholder="Increase / Decrease"
                                value={block.shortfall}
                                onChange={(e) => handleAssistanceChange(index, "shortfall", e.target.value)}
                                step="0.01"
                                disabled
                            />
                            {errors[`assistance_shortfall_${index}`] && (
                                <p className="text-danger small">{errors[`assistance_shortfall_${index}`]}</p>
                            )}
                        </div>
                    </div>

                            {/* Work Completion Details */}
                    <div className="d-flex border-bottom border-secondary">
                        <h4 className="col-1"></h4>
                        <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                            <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">06.</h4>
                            <p className="col-10 p-2 d-flex align-items-center">કામ પૂર્ણ થયાની વિગતો (Details of Work Completion)*</p>
                        </div>
                        <div className="col-5 d-flex flex-column align-items-center my-2 justify-content-center">
                            {fileButtonFn("hasAssistanceApproved", `details_${index+1}`, 'annexureThree')}
                        </div>
                        </div>
                        {/* <div className="d-flex border-bottom border-secondary">
                        <h4 className="col-1"></h4>
                        <div className="d-flex w-100 gap-2 border-start border-end border-secondary">
                            <h4 className="col-2 d-flex align-items-center justify-content-center border-end border-secondary">07.</h4>
                            <p className="col-10 p-2 d-flex align-items-center">શેરો – Share (or Contribution/Ratio, depending on context)*</p>
                        </div>
                        <div className="col-5 d-flex flex-column align-items-center justify-content-center">
                           
                            <input
                                type="number"
                                className="w-75 m-2 form-control"
                                placeholder="contribution"
                                value={block?.contribution}
                                onChange={(e) => handleAssistanceChange(index, "contribution", e.target.value)}
                                step="0.01"
                            />
                            {errors[`assistance_shortfall_${index}`] && (
                                <p className="text-danger small">{errors[`assistance_shortfall_${index}`]}</p>
                            )}
                        </div>
                    </div> */}

                {/* Action Buttons */}
                {/* <div className="d-flex border-bottom border-secondary px-3 py-2 justify-content-end gap-3">
                    {/* Add More Button 
                    {index === detailAssistanceReceived.length - 1 && detailAssistanceReceived.length < 6 && (
                        <button
                            type="button"
                            className="btn text-info d-flex align-items-center gap-2"
                            style={{ backgroundColor: 'transparent', boxShadow: 'none', border: 'none' }}
                            onClick={addAssistanceBlock}
                        >
                            <i className="feather feather-plus-circle"></i> Add More
                        </button>
                    )}

                    {/* Remove Button 
                    {detailAssistanceReceived.length > 1 && (
                        <button
                            type="button"
                            className="btn text-danger d-flex align-items-center gap-2"
                            style={{ backgroundColor: 'transparent', boxShadow: 'none', border: 'none' }}
                            onClick={() => removeAssistanceBlock(index)}
                        >
                            <i className="feather feather-trash"></i> Remove
                        </button>
                    )}
                            </div> */}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </div>

        {/* Agreement Section */}
        
        <div className="d-flex align-items-center">
        {roleIdentifier!=="SA"&&  <div
            className={`m-5 w-75 d-flex flex-row align-items-start gap-3 border border-secondary rounded mb-5 p-3 bg-white 
              ${agreeError ? "bg-danger-subtle" : ""}`}
          >
            {/* Left Side - Checkbox */}
          <div className="pt-2">
              <input
                className="form-check-input "
                type="checkbox"
                name="agreeTerms"
                id="agreeTerms"
                checked={agreeTerms}
                onChange={(e) => {
                  setAgreeTerms(e.target.checked);
                  setAgreeError(false); // 🔥 remove error once checked
                }}
                style={{ transform: "scale(1.5)" }}
              />
            </div>


                {/* Right Side - Agreement Text */}
                
                <div className="flex-grow-1">
  <div className="p-2 rounded">
    <p>
      આમ, ઉક્ત તમામ વિગતો સંબંધિત બજાર સમિતિની દરખાસ્ત અને જિલ્લા રજિસ્ટ્રાર / જિલ્લા રજિસ્ટ્રાર દ્વારા નિયુક્ત થયેલ કર્મચારીની સ્થળ તપાસના આધારે ખરી છે. અને આ વિગતો મે જાતે ચકાસી છે. અને આ વિગતોના આધારે મારો સ્પષ્ટ અભિપ્રાય છે કે બજાર સમિતિ પ્રોજેક્ટ પૂર્ણ કરવા <span className="fw-bold">{(certificate?.projectCapability || existData?.projectCapability) === "capable" ? "સક્ષમ" : "અસક્ષમ"}</span> છે.
      (Thus, all the above-mentioned details are accurate based on the proposal of the concerned Market Committee and the site inspection conducted by the District Registrar / the employee appointed by the District Registrar. I have personally verified these details. Based on this information, it is my clear opinion that the Market Committee is <span className="fw-bold">{(certificate?.projectCapability || existData?.projectCapability) === "capable" ? "capable" : "not capable"}</span> of completing the project.)
    </p>
  </div>
</div>

            </div>}

            {/* Action Buttons */}
            <div className=" justify-content-between align-items-stretch me-5 gap-2">
                       <textarea
                    className="form-control mb-3"
                    placeholder="Enter your comment"
                    name="currAt"
                    value={centralComment!=""? centralComment : ""} // Bind value to state
                    onChange={(e) => setCentralComment(e.target.value)} // Update state on type
                    rows={4} // Adjust number of rows as needed
                    // maxLength={100}
                  />
                <div className="d-flex justify-content-between align-items-stretch me-5 gap-2">
                <button type="button" className="btn btn-secondary p-3" onClick={handleBack}>Back</button>
                
                {/* Next Button for specific roles */}
                {(["SC", "HOS", "DT", "DY", "Dr","SA"].includes(roleIdentifier)) && (
                    <div className="d-flex h-100">
                        <button type="button" className="btn btn-info p-3" onClick={goToCertificate}>Next</button>
                    </div>
                )}

                {/* Next Button for JC role with specific condition */}
                {["JC"].includes(roleIdentifier) && existData.appStatusLevel == "returnToDClerkForwardingToHO" &&
                    <div className="d-flex">
                        <button type="button" className="btn btn-info" onClick={goToCertificate}>Next</button>
                    </div>
                }

                {/* Action Buttons for other roles */}
                {!["Dr", "HOS", "DT", "DY", "SC"].includes(roleIdentifier) && existData.appStatusLevel != "returnToDClerkForwardingToHO" &&
                    <div className="d-flex gap-2">
                        {existData.buttonName && existData?.buttonName.map((button: any) => (
                            <button
                                key={button.status}
                                type="button"
                                className={`btn ${button.status === "reject"
                                    ? "btn-danger"
                                    : button.status === "permanentReject" ? "btn-secondary" : "btn-success"
                                    } ms-3`}
                                onClick={() => handleFinalSubmit(button.status, button.appStatusLevel)}
                            >
                                {button.buttonLabel}
                            </button>
                        ))}
                    </div>
                }
                </div>
            </div>
        </div>

        {/* Modal Component */}
        <SingleView docId={selectedDocId} type="Scheme"/>
    </>
);
}

export default DistrictPage